import classnames from 'classnames'
import { ButtonListOption, mapStateToProps } from 'embed/components/ButtonList'
import {
  BLANK_STRING,
  ButtonListFieldDirectionOption,
  FieldDataValue,
  FieldSelectOption,
  MultiButtonListFieldOptions,
} from 'embed/constants'
import { css } from 'emotion'
import * as React from 'react'
import { connect } from 'react-redux'

const styles = require('./styles')

export interface MultiButtonListProps {
  onChange: (values?: FieldDataValue) => void
  options: MultiButtonListFieldOptions
  value?: FieldDataValue
  name: string
}

interface StoreProps {
  listOptions?: FieldSelectOption[]
}

type Props = MultiButtonListProps & StoreProps

const isNoneOfTheseChecked = (value) => Array.isArray(value) && value.length === 0

const getChangedValues = (value, fieldDataValue: string) => {
  const values = new Set(Array.isArray(value) ? value : [])
  if (values.has(fieldDataValue)) {
    values.delete(fieldDataValue)
  } else {
    values.add(fieldDataValue)
  }
  return values
}

const MultiButtonList: React.FC<Props> = (props) => {
  const { onChange, name, options, value } = props
  const { allowNone } = options

  const buttonOptions = options.selectOptions
    ? options.selectOptions.filter((option) => option.value !== BLANK_STRING)
    : props.listOptions
  const direction = options.direction ?? ButtonListFieldDirectionOption.Column

  const handleChange = (fieldDataValue?: string) => {
    // If they selected 'none of these', set the value to an empty array
    if (fieldDataValue === undefined) {
      onChange([])
    } else {
      const changedValues = getChangedValues(value, fieldDataValue)
      // Set to undefined if no values are selected (e.g. the user unselects a previously selected value)
      changedValues.size === 0 ? onChange(undefined) : onChange(Array.from(changedValues.values()))
    }
  }

  const isChecked = (fieldDataValue: string) => {
    if (Array.isArray(value)) {
      return value.includes(fieldDataValue)
    }
    return false
  }

  return (
    <div
      className={classnames(
        styles.multiButtonList,
        css`
          flex-direction: ${direction};
        `,
        { [styles.buttonListRow]: direction === ButtonListFieldDirectionOption.Row },
      )}
    >
      {buttonOptions &&
        buttonOptions.map((option, index) => (
          <ButtonListOption
            checked={isChecked(option.value)}
            key={option.value}
            label={option.label}
            name={`${name}_${index}`}
            onClick={handleChange}
            value={option.value}
            direction={direction}
            multiSelect={true}
            centerAlign={true}
          />
        ))}
      {allowNone && (
        <div className={styles.noneOptionList}>
          <ButtonListOption
            checked={isNoneOfTheseChecked(value)}
            label={'None of these'}
            name={`${name}_none`}
            onClick={handleChange}
            centerAlign={true}
            hideEmptyCheck={true}
          />
        </div>
      )}
    </div>
  )
}

export default connect<StoreProps>(mapStateToProps, {})(MultiButtonList)
